import { Input } from "components/base/Form";
import { useState } from "react";

const SuggestedActionsCard = ({ actions }) => {
  const [query, setQuery] = useState("");

  console.log("actions", actions);

  const normalizedQuery = query.toLowerCase().trim();
  const filteredActions = normalizedQuery
    ? actions.filter((item) => {
        return (
          item.target.toLowerCase().includes(normalizedQuery) ||
          item.action.toLowerCase().includes(normalizedQuery) ||
          item.reason.toLowerCase().includes(normalizedQuery)
        );
      })
    : actions;

  return (
    <div className="card">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
        <h5>Suggested To Do</h5>
        <div className="w-full lg:w-96">
          <Input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search suggested actions by target or step..."
            className="w-full"
          />
        </div>
      </div>
      <div className="text-xs opacity-60 mt-1">
        Suggested actions returned by AI Brief with reason and expected impact.
      </div>
      <div className="-mx-2">
        <table className="with-line mt-3">
          <thead>
            <tr>
              <th>Entity</th>
              <th>Suggested To Do</th>
              <th>Reason</th>
              <th>Expected Impact</th>
            </tr>
          </thead>
          <tbody>
            {filteredActions.map((row) => (
              <tr key={row.id}>
                <td>{row.target}</td>
                <td>{row.action}</td>
                <td>{row.reason}</td>
                <td>{row.impact}</td>
              </tr>
            ))}
            {filteredActions.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center opacity-60 py-4">
                  No suggested actions.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SuggestedActionsCard;
